
















































































































































































































import { Component, Vue } from 'vue-property-decorator';
import Widget from '@/components/Widget.vue';
import Announcement from '@/components/Announcement.vue';
import { vxm } from '../store';
@Component({
  components: {
    Widget,
    Announcement,
  },
  computed: {
    isLogin: () => vxm.login.isLogin,
  },
})
export default class extends Vue {
  private get liveUrl(): string {
    return process.env.NODE_ENV === 'production'
      ? `https://live.monkey-monkey.com`
      : `https://live.monkeyfhb.com`;
  }
}
